import { render, staticRenderFns } from "./PermitDeleted.vue?vue&type=template&id=66bd7015"
import script from "./PermitDeleted.vue?vue&type=script&lang=js"
export * from "./PermitDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports